export class ZstdBuffer {
  constructor(public positionPtr: number, public size: number, public dataPtr: number) {}
}
